import {ref, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
    listTransactions,
    createTransaction,
    updateTransaction,
    deleteTransaction,
} from '@/api/transactions';
import {
    listAccounts,
} from '@/api/accounts';
import {
    listCategories,
} from '@/api/categories';
import AccountsPage from "@/features/accounts/pages/AccountsPage.vue";


export function useTransactions() {
    const route = useRoute();
    const router = useRouter();
    const transactions = ref([]);
    const accounts = ref([]);
    const sumByCategory = ref([]);
    const categories = ref([]);
    const selectAccountId = ref('');
    const accountCurrency = ref('');
    const loading = ref(false);
    
    const isSuccess = ref(false);
    const messageSuccess = ref('');
    const messageError = ref('');
    
    const page = ref( Number(route.query.page ?? 1) );
    const size = ref( Number(route.query.size ?? 10) );
    const summaryType = ref( '' );
    const accountName = ref( '' );
    const summaryAmount = ref( Number(0) );
    const totalPages = ref( Number(0) );
    const totalElements = ref( Number(0) );
    
    function setSuccess(msg) {
        messageSuccess.value = msg;
        isSuccess.value = true;
    }
    
    function setError(msg) {
        messageError.value = msg;
        isSuccess.value = false;
    }
    
    async function load(accountId, pageArg = 1, sizeArg = 20, filter = {}) {
        loading.value = true;
        try {
            const accountData = await listAccounts(1, 1000);
            accounts.value = accountData.content;
            const categoriesData = await listCategories();
            categories.value = categoriesData.content;
            if (!selectAccountId.value && accounts.value.length) {
                selectAccountId.value = accounts.value[0].id;
            }
            if (accounts.value.length) {
                const data = await listTransactions(accountId, pageArg, sizeArg, filter);
                transactions.value = data.content || [];
                page.value = data.number + 1;
                size.value = data.size;
                totalPages.value = data.totalPages;
                totalElements.value = data.totalElements;
                summaryType.value = data?.meta?.sum?.type ?? '';
                summaryAmount.value = data?.meta?.sum?.sum ?? '';
                accountCurrency.value = data?.meta?.accountCurrency ?? '';
                sumByCategory.value = data?.meta?.sumByCategory ?? '';
                accountName.value = data?.meta?.accountName ?? '';
            }
        } catch (e) {
            
            if (e?.code === 'account_not_found') {
                await router.push({
                    name: 'Accounts',
                });
            }
            setError('Не удалось загрузить');
        } finally {
            loading.value = false;
        }
    }
    
    async function addTransaction(accountId, payload) {
        try {
            await createTransaction(accountId, payload);
            setSuccess('Транзакция добавлена');
        } catch (e) {
            setError('Не удалось добавить транзакцию');
            if (e?.code === 'account_less_zero') setError('Баланс аккаунта не может быть меньше нуля');
        }
    }
    
    async function updateTransactionById(accountId, id, payload) {
        try {
            await updateTransaction(accountId, id, payload);
            setSuccess('Транзакция обновлена');
        } catch (e) {
            setError('Не удалось добавить транзакцию');
            if (e?.code === 'account_less_zero') setError('Баланс аккаунта не может быть меньше нуля');
        }
    }
    
    async function deleteTransactionById(accountId, id) {
        try {
            await deleteTransaction(accountId, id);
            setSuccess('Транзакция удалена');
        } catch (e) {
            
            setError('Не удалось удалить транзакцию');
        }
    }
    
    return {
        transactions,
        sumByCategory,
        accounts,
        categories,
        loading,
        isSuccess,
        messageError,
        messageSuccess,
        page,
        size,
        totalPages,
        totalElements,
        summaryAmount,
        summaryType,
        accountName,
        accountCurrency,
        load,
        addTransaction,
        updateTransactionById,
        deleteTransactionById,
    };
}
